import React from "react";
import {
  ActivityWrapper,
  ActivityItem,
  ActivityItemDetail,
  ActivityItemDetailList,
} from "../DocumentDetailSlideout.styled";
import { Typography } from "@ann/web-components";

export const ActivityContent = () => {
    const mockData = [
        {
            title: "Today",
            content: [
                {
                    description: "Mike Abbott renamed this document to “OEM Submission...",
                    realDate: "Aug  20, 2025 at 3:45 PM"
                },
                {
                    description: "12 files attached by Jhon SmithIncludes diagnostics.xlsx...",
                    realDate: "Aug  20, 2025 at 3:45 PM"
                },
            ]
        },
        {
            title: "Last week",
            content: [
                {
                    description: "Mover to folder “Warranty Claims”",
                    realDate: "Aug  20, 2025 at 3:45 PM"
                },
                {
                    description: "Mover to folder “Warranty Claims”",
                    realDate: "Aug  20, 2025 at 3:45 PM"
                },
            ]

        },
        {
            title: "3 weeks ago",
            content: [
                {
                    description: "Assigned to Support Agent",
                    realDate: "Aug  20, 2025 at 3:45 PM"
                },
                {
                    description: "Assigned to Support Agent",
                    realDate: "Aug  20, 2025 at 3:45 PM"
                },
            ]
        },
        {
            title: "A month ago",
            content: [
                {
                    description: "Shared with 3 users Emma, Andrew, Jhon",
                    realDate: "Aug  20, 2025 at 3:45 PM"
                },
                {
                    description: "Shared with 3 users Emma, Andrew, Jhon",
                    realDate: "Aug  20, 2025 at 3:45 PM"
                },

            ]
        },
    ]
    return (
        <ActivityWrapper>
            <ActivityItem>
                {mockData.map((item)=> (
                    <ActivityItem>
                        <Typography category="subtitle" size="small" weight="bold">
                            {item.title}
                        </Typography>
                            <ActivityItemDetail>
                                <ul className={"item-list"}>
                                    {item.content.map((content)=> (
                                        <li>
                                            <ActivityItemDetailList>
                                                <Typography category="body" size="small" weight="regular" color="body">
                                                    {content.description}
                                                </Typography>
                                                <Typography category="body" size="small" weight="regular" color="body">
                                                    {content.realDate}
                                                </Typography>
                                            </ActivityItemDetailList>
                                        </li>
                                    ))}
                                </ul>
                            </ActivityItemDetail>
                    </ActivityItem>
                ))}
            </ActivityItem>

        </ActivityWrapper>
    )
}
